@let configurationRow = row();

@if (configurationRow.kind === "supported") {
  <fieldset
    [formGroup]="configurationRow.form"
    class="configuration-row"
    [class.configuration-row-custom-signal]="
      configurationRow.form.controls.configuration.controls.operation.value === 'door.customSignal'
    "
  >
    <div class="field">
      <label [for]="configurationRow.id + '-adapter-type'">
        {{ "gate_administration.hardware_configuration.adapter_type" | translate }}*
      </label>
      <p-select
        [inputId]="configurationRow.id + '-adapter-type'"
        formControlName="adapterType"
        [options]="adapterTypeOptions()"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        class="w-full"
      >
        <ng-template let-option #selectedItem>
          {{ option.label | translate }}
        </ng-template>
        <ng-template let-option #item>
          {{ option.label | translate }}
        </ng-template>
      </p-select>
    </div>

    @switch (configurationRow.form.controls.adapterType.value) {
      @case (hardwareAdapterType.BUTLER_V1) {
        <app-butler-v1-configuration-row
          [form]="configurationRow.form.controls.configuration"
          [controlIdPrefix]="configurationRow.id"
          [operationOptions]="operationOptions()"
          [indexOptions]="indexOptions()"
        />
      }
    }

    @if (canEdit()) {
      <app-svg-icon
        iconName="trash"
        iconColor="primary"
        class="remove-button pointer"
        [attr.aria-label]="'gate_administration.hardware_configuration.remove_row' | translate"
        (click)="removeRequested.emit()"
      />
    }

    @if (getValidity(configurationRow); as validity) {
      <div class="configuration-validity" role="status">
        <div class="validity-summary">
          <span
            class="validity-dot"
            [class.validity-dot-valid]="validity.status === 'valid'"
            [class.validity-dot-invalid]="validity.status === 'invalid'"
            [class.validity-dot-pending]="validity.status === 'pending'"
            aria-hidden="true"
          ></span>
          <span
            [class.validity-text-valid]="validity.status === 'valid'"
            [class.validity-text-invalid]="validity.status === 'invalid'"
            [class.validity-text-pending]="validity.status === 'pending'"
          >
            {{ "gate_administration.hardware_configuration.validity." + validity.status | translate }}
            @if (validity.status === "invalid") {
              @for (issue of validity.issues; track issue) {
                {{ "gate_administration.hardware_configuration.validity.issues." + issue | translate }}
              }
            }
          </span>
        </div>
      </div>
    }
  </fieldset>
} @else {
  <fieldset class="configuration-row configuration-row-unsupported">
    <div class="field">
      <span class="field-label">{{ "gate_administration.hardware_configuration.adapter_type" | translate }}</span>
      <span>{{ configurationRow.adapterType }}</span>
    </div>

    <p class="unsupported-message" role="status">
      {{ "gate_administration.hardware_configuration.unsupported_type" | translate }}
    </p>

    @if (canEdit()) {
      <app-svg-icon
        iconName="trash"
        iconColor="primary"
        class="remove-button pointer"
        [attr.aria-label]="'gate_administration.hardware_configuration.remove_row' | translate"
        (click)="removeRequested.emit()"
      />
    }
  </fieldset>
}
